import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedUiAlertModule} from "@snelstart/ui-alert";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-div-dividendbelasting',
  standalone: true,
  imports: [CommonModule, SharedUiAlertModule],
  templateUrl: './tekst-dividendbelasting.component.html',
  styleUrl: './tekst-dividendbelasting.component.scss',
})
export class TekstDividendbelastingComponent {}
